export const enMap: Record<string, any> = {
  welcome: {
    title: "Welcome to Inventorization Asset Management",
    subtitle: "Fill your credentials below",
    trailingText: "Your credentials are stored in a secure database. We will never share your information with anyone.",
    demoText: "You can also use the following credentials to login as a demo user",
    email: "Email",
    password: "Password",
  },
  signin: {
    form: {
      emailLabel: "Email",
      emailPlaceholder: "Email address",

      passwordLabel: "Password",
      passwordPlaceholder: "Password",

      submit: "Log In",
    },
  },
  dashboard: {
    inputSelect: "Select",
    inputEnter: "Enter",
    navbarTitle: "Dashboard",

    sidebar: {
      dashboardLabel: "Dashboard",
      assetsLabel: "Assets",
      usersLabel: "Users",
      rolesLabel: "Roles",
      professionsLabel: "Professions",
      checkLabel: "Check Assets",
      requestsLabel: "Requests",
      "check-assetsLabel": "Check Assets",
      typesLabel: "Asset Types",
      accountLabel: "Account",
      logout: "Log Out",
      aboutLabel: "Who we are?",
      contactLabel: "Contact Us",
    },

    onPageSearchInputLabel: "On Page Search",
    onPageSearchInputPlaceholder: "Enter search keyword...",

    filterByType: "Filter by Type",

    user: {
      welcome: "Welcome to Inventorization Asset Management Platform!",
      accordion: {
        title1: "What is Invasman?",
        description1:
          "An Inventory Asset Management System is a comprehensive software solution designed to streamline the tracking, monitoring, and management of physical assets within an organization. It provides users with a centralized platform to efficiently oversee asset lifecycles, from procurement to disposal. Key features typically include asset tracking, inventory control, request management, reporting, and analytics. Ultimately, an Inventory Asset Management System empowers businesses to make informed decisions, minimize asset downtime, and maximize return on investment.",

        title2: "How Assets are Managed for You?",
        description2:
          "Gain full visibility and control over all assets assigned to you within the organization. Our comprehensive asset overview provides detailed insights into every asset under your responsibility. Track assets by their unique identifiers, such as UUID or asset categories. By centralizing asset information, you can effectively manage asset utilization, minimize loss or theft, and ensure compliance with asset policies and regulations.",

        title3: "Request History Overview and Management",
        description3:
          "Keep track of all your asset requests from initiation to fulfillment with our request history feature. Submit, review, and manage requests seamlessly through a user-friendly interface. Monitor the status of pending requests and receive ready status upon completion. Access a comprehensive history of past requests, including details such as request date, requested items, approval status, and the reason. By having full visibility into your request history, you can streamline procurement processes, identify trends, and optimize resource allocation.",

        title4: "Don't Forget to Manage & Secure Your Profile",
        description4:
          "Take control of your user experience and personal preferences with our comprehensive account management feature. Manage your account settings effortlessly, including profile information and login credentials. Our user-friendly interface ensures that account management tasks are simple and intuitive, empowering you to stay connected and engaged with the platform.",
      },
    },
    monitoring: {
      requestsBarTitle: "Requests Monitoring Bar",
      requestsAreaTitle: "Requests Monitoring Area",

      assetTypes: "Asset Types",
      availableAssets: "Available Assets",
      pendingRequests: "Pending Requests",
      registeredAccounts: "Registered Accounts",
      professions: "Professions",

      availableAssetsByType: "Available Assets by Type",
      count: "Count",
      assetsCount: "Assets Count",
    },
    requests: {
      create: "Create",
      discard: "Discard",
      newRequest: "New Request",

      seeAllPending: "See All Pending Requests",
      pendingRequestsMessage: "You have {{count}} pending request(s).",

      replacementYes: "Yes",
      replacementNo: "No",

      deleteSelected: "Delete Selected Requests",

      approveSelected: "Approve Selected Requests",
      declineSelected: "Decline Selected Requests",

      selectAsset: "Select Asset",
      selectNotRequestedAsset: "Select Not Requested Asset",

      filterStatusPlaceholder: "Status",

      headers: {
        id: "id",
        status: "Status",
        action: "Action",
        reason: "Reason",
        replacement: "Replacement",
        asset: "Asset",
        created: "Created",
        owner: "Owner",
      },

      filterByStatus: "Filter by Status",
    },
    assets: {
      create: "Create",
      discard: "Discard",
      newAsset: "New Asset",

      assignToUser: "Assign to User",

      checkNoticeToday: "You have assets to check today. Please check them as soon as possible.",

      unassignSelected: "Unassign Selected Assets",
      deleteSelected: "Delete Selected Assets",

      countPlaceholder: "Count",

      markAssetsAsChecked: "Mark Assets as Checked",

      headers: {
        id: "id",
        uuid: "uuid",
        name: "Name",
        type: "Type",
        createdAt: "Created At",
        checkDate: "Check Date",
        user: "User",
      },
    },
    users: {
      filterByRole: "Filter by Role",

      headers: {
        id: "id",
        name: "Name",
        lastname: "Lastname",
        username: "Username",
        email: "Email",
        password: "Password",
        registered: "Registered",
        avatar: "Avatar",
        role: "Role",
        profession: "Profession",
        actions: "Actions",
      },

      create: "Create",
      discard: "Discard",
      newUser: "New User",

      deleteSelected: "Delete Selected Users",
    },
    roles: {
      headers: {
        id: "id",
        name: "Name",
        accessLevel: "Access Level",
        description: "Description",
      },

      labels: {
        admin: "Director",
        moderator: "Manager",
        user: "User",
      },

      descriptions: {
        admin: "Complete Control and Privileges",
        moderator: "Partial Control and Management Abilities",
        user: "Limited Access and Basic Functionality",
      },
    },
    professions: {
      create: "Create",
      discard: "Discard",
      newProfession: "New Profession",

      deleteSelected: "Delete Selected Professions",

      descriptionPlaceholder: "Description",
      selectAssetsLabel: "Select Assets",

      headers: {
        id: "id",
        name: "Name",
        description: "Description",
        assets: "Assets",
      },
    },
    types: {
      create: "Create",
      discard: "Discard",
      newType: "New Type",

      deleteSelected: "Delete Selected Types",

      descriptionPlaceholder: "Description",

      headers: {
        id: "id",
        name: "Name",
        description: "Description",
      },
    },
    account: {
      nameInputLabel: "Name",
      lastnameInputLabel: "Lastname",
      usernameInputLabel: "Username",
      emailInputLabel: "Email",

      currentPasswordInputLabel: "Current Password",
      currentPasswordPlaceholder: "Enter current password",

      newPasswordInputLabel: "New Password",
      newPasswordPlaceholder: "Enter new password",

      confirmPasswordInputLabel: "Confirm Password",
      confirmPasswordPlaceholder: "Enter new password",

      updatePasswordButton: "Update Password",

      allPasswordsRequired: "All passwords are required",
      passwordsDoNotMatch: "New password and confirm password must be same",

      securityDescription:
        "Account information is secure and private. Please be careful when changing your credentials. To have privacy for account, after changing password, you will be logged out.",

      autogeneratedAvatar: "This is an autogenerated unique avatar for your account",

      passwordRequirements: {
        title: "Password Minimum Requirements",
        length: "Minimum Length: 6",
        uppercase: "At least one uppercase letter",
        lowercase: "At least one lowercase letter",
        number: "At least one number",
      },
    },
    contact: {
      title: "Let's see how we can help you",
      description:
        "We are here to help you. If you have any questions or need assistance, please feel free to contact us. We will get back to you as soon as possible.",
      emailLabel: "Send us an email",
      manualLabel: "Or manually send an email to",
    },
    about: {
      title: "Let's get to know each other",
      description:
        "The best way to know about us is to go through the accordion below. You will find all the information you need. If you have any questions, please do not hesitate to contact us.",

      accordion: {
        title1: "What is Invasman?",
        description1:
          "An Inventory Asset Management System is a comprehensive software solution designed to streamline the tracking, monitoring, and management of physical assets within an organization. It provides users with a centralized platform to efficiently oversee asset lifecycles, from procurement to disposal. Key features typically include asset tracking, inventory control, request management, reporting, and analytics. Ultimately, an Inventory Asset Management System empowers businesses to make informed decisions, minimize asset downtime, and maximize return on investment.",

        title2: "The Importance of Asset Management",
        description2:
          "Asset management is essential for organizations of all sizes and industries. By implementing an effective asset management system, businesses can optimize asset utilization, reduce operational costs, and enhance productivity. Asset management also helps organizations comply with regulatory requirements, mitigate risks, and improve decision-making processes. Ultimately, asset management enables businesses to maximize the value of their assets and achieve long-term success.",

        title3: "Our Mission and Vision",
        description3:
          "Our mission is to provide organizations with a powerful and user-friendly platform to manage their assets effectively. We are committed to delivering innovative solutions that streamline asset management processes, enhance visibility, and drive operational efficiency. Our vision is to become the leading provider of asset management software, empowering businesses to achieve their asset management goals and drive growth.",

        title4: "Why Choose Invasman?",
        description4:
          "Invasman is the ideal asset management solution for businesses looking to optimize their asset management processes. Our platform offers a wide range of features and functionalities designed to meet the unique needs of organizations across industries. From asset tracking and inventory control to request management and reporting, Invasman provides everything you need to manage your assets effectively. With our intuitive interface, robust security features, and dedicated support team, Invasman is the smart choice for businesses seeking a reliable asset management solution.",

        title5: "Get in Touch",
        description5:
          "If you have any questions about Invasman or would like to learn more about our asset management software, please don't hesitate to contact us. Our team is here to help and provide you with the information you need to make an informed decision. Get in touch with us today to discover how Invasman can help you streamline your asset management processes and achieve your business goals.",
      },
    },
  },
};
